import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import "../../assets/css/hamburger.css";
import SalaryBoard from "../../components/salary/board";
import NavBar from "../../components/general/NavBarApp";

const Politique = () => {
  return (
    <div className="main">
      <NavBar userType="interim" />
      <SalaryBoard />
    </div>
  );
};

export default Politique;
